// extracted by mini-css-extract-plugin
export var danger = "_3f-6";
export var lightPink = "_3f-a";
export var medium = "_3f-j";
export var nearSquare = "_3f-m";
export var neutralBlue = "_3f-8";
export var neutralYellow = "_3f-7";
export var noCapitalize = "_3f-1";
export var normal = "_3f-2";
export var pill = "_3f-0";
export var primary = "_3f-3";
export var primaryLight = "_3f-4";
export var shadow = "_3f-n";
export var small = "_3f-k";
export var solidBlack = "_3f-i";
export var solidGreen = "_3f-d";
export var solidLightBlue = "_3f-f";
export var solidNavy = "_3f-e";
export var solidOrange = "_3f-h";
export var solidPink = "_3f-g";
export var solidRed = "_3f-b";
export var solidWhite = "_3f-9";
export var solidYellow = "_3f-c";
export var success = "_3f-5";
export var xsmall = "_3f-l";